import { getManualProjectId } from '@/lib/base/project';

export default {
  computed: {
    manualProjectId() {
      return getManualProjectId(this.selectedProject._id);
    },
    manualProject() {
      const projectList = this.$store.getters['project/projectList'];
      return projectList.find(p => p._id === this.manualProjectId) || this.selectedProject;
    },
  },
};
